import React from 'react';
import { useIntl } from 'react-intl';
import { Alert } from 'reactstrap';
import { TypedMemo } from '../../../../common/types';
import { ReelConflictCode } from './reelRefusal';
import { reelReviewMessages } from './reelReviewMessages';

/** Design d4: a 409. The app loaded the reel again; this says why the action did not happen. */
const ReelConflictAlertComponent: React.FC<{ code: ReelConflictCode }> = ({ code }) => {
  const intl = useIntl();
  const isRegenerate = code === 'REEL_NOT_REGENERATABLE';

  return (
    <Alert color="danger" className="mb-0" role="alert">
      <strong>
        {intl.formatMessage(
          isRegenerate ? reelReviewMessages.conflictRegenerateTitle : reelReviewMessages.conflictApproveTitle
        )}
      </strong>
      <br />
      {intl.formatMessage(
        isRegenerate ? reelReviewMessages.conflictRegenerateBody : reelReviewMessages.conflictApproveBody
      )}
    </Alert>
  );
};

export const ReelConflictAlert = TypedMemo(ReelConflictAlertComponent);
